import { BadgeCheck, BookOpen, BoxesIcon, BoxIcon, FileText, FolderTree, Home, Image, Mail, MessageCircle, Package, Settings, Send, Share, Share2, Shield, ShoppingBag, Star, UserKey, UserLockIcon, Users, Users2Icon, UsersIcon, BadgeQuestionMark, MapPinned, Building2, Landmark, FlaskConical, FileTex, BookUserIcon, } from "lucide-react";
import { SideBarItem } from "./SideBarItem";
import { ROUTE_PATHS } from "../../../../constants/routeConstants";
import { NavLink } from "react-router-dom";


export const ROUTE_CONFIG = {
  DASHBOARD: { path: ROUTE_PATHS.DASHBOARD, label: "Dashboard" },
  USERS: { path: ROUTE_PATHS.USERS, label: "Users" },
  ROLES: { path: ROUTE_PATHS.ROLES, label: "Roles" },
  ASSIGN_PERMISSIONS: { path: ROUTE_PATHS.ASSIGN_PERMISSIONS, label: "Assign Permissions" },
  DISTRICT: { path: ROUTE_PATHS.DISTRICT_LIST, label: "District" },
  UNIT: { path: ROUTE_PATHS.UNIT_LIST, label: "Unit" },
  TALUKA: { path: ROUTE_PATHS.TALUKA_LIST, label: "Taluka" },
  PATIENT: { path: ROUTE_PATHS.PATIENT_LIST, label: "Patients" },
  PATIENT_VISIT: { path: ROUTE_PATHS.PATIENT_VISIT_LIST, label: "Patient Visits" },
  REFERREL_LIST: { path: ROUTE_PATHS.REFERREL_LIST, label: "Referrel List" },
  REFERREL_CREATE: { path: ROUTE_PATHS.REFFERAL_CREATE, label: "Create Referrel" },
  LABTEST: { path: ROUTE_PATHS.LABTESTLIST, label: "Lab Test" },
  LAB_REPORT: { path: ROUTE_PATHS.LAB_REPORT_LIST, label: "Lab Report" }



};


const SideBarData = () => {
  return <>

    <SideBarItem link={ROUTE_CONFIG.DASHBOARD.path}
      noPermission={true}
      text={ROUTE_CONFIG.DASHBOARD.label}
      icon={<Home />} />

    <SideBarItem
      icon={<Users />}
      text="Users Management"
      subItems={[
        {
          text: ROUTE_CONFIG.USERS.label,
          link: ROUTE_PATHS.USERS,
          module: "user",
          permission: "read_user"
        },
        {
          text: ROUTE_CONFIG.ROLES.label,
          link: ROUTE_PATHS.ROLES,
          permission:"read_role",
          module:"role"
        },
        {
          text:ROUTE_CONFIG.ASSIGN_PERMISSIONS.label,
          link: ROUTE_PATHS.ASSIGN_PERMISSIONS,
          permission:"assign_permission",
          module:"permission"
        },
      ]}
    />

    <SideBarItem
      text={"Location Management"}
      icon={<MapPinned />}
      subItems={[
        {
          text: ROUTE_CONFIG.DISTRICT.label,
          link: ROUTE_PATHS.DISTRICT_LIST,
          permission:"read_district",
          module:"district"
        },
        {
          text: ROUTE_CONFIG.UNIT.label,
          link: ROUTE_CONFIG.UNIT.path,
          permission:"read_unit",
          module:"unit"
        },
        {
          text: ROUTE_CONFIG.TALUKA.label,
          link: ROUTE_CONFIG.TALUKA.path,
          permission:"read_taluka",
          module:"taluka"
        }
      ]}
    />
    {/* <SideBarItem
      module={"patient"}
      permission={"read_patient"}
      link={ROUTE_CONFIG.PATIENT.path}
      text={ROUTE_CONFIG.PATIENT.label}
      icon={<Users />}
    /> */}
    <SideBarItem
      text={"Patients Management"}
      icon={<BookUserIcon />}
      subItems={[
        {
          text: ROUTE_CONFIG.PATIENT.label,
          link: ROUTE_CONFIG.PATIENT.path,
          permission:"read_patients",
          module:"patient"
        },
        
        {
          text: ROUTE_CONFIG.PATIENT_VISIT.label,
          link: ROUTE_CONFIG.PATIENT_VISIT.path,
          permission:"read_vist_patients",
          module:"patient_visit"
        },

          {
          text: ROUTE_CONFIG.REFERREL_LIST.label,
          link: ROUTE_CONFIG.REFERREL_LIST.path,
          permission:"read_referrel_patients",
          module:"patient_referrel"

        }
        
      ]}
    />
    <SideBarItem
      text={"Lab Management"}
      icon={<FlaskConical />}
      subItems={[
        {
          text: ROUTE_CONFIG.LABTEST.label,
          link: ROUTE_CONFIG.LABTEST.path,
          permission:"read_lab_test",
          module:"lab_test"
        },
        {
          text: ROUTE_CONFIG.LAB_REPORT.label,
          link: ROUTE_CONFIG.LAB_REPORT.path,
          permission:"read_lab_report",
          module:"lab_report"
        }
      ]}
    />
    {/* 
  
    <SideBarItem module={"product_category"} permission={"read_product_category"}
      link={ROUTE_CONFIG.PRODUCT_CATEGORY.path}
      text={ROUTE_CONFIG.PRODUCT_CATEGORY.label}
      icon={<Package  />}
    />
    <SideBarItem module={"product_subcategory"} permission={"read_product_subcategory"}
      link={ROUTE_CONFIG.PRODUCT_SUB_CATEGORY.path}
      text={ROUTE_CONFIG.PRODUCT_SUB_CATEGORY.label}
      icon={<FolderTree />}
    />
    <SideBarItem module={"product"} permission={"read_product"}
      link={ROUTE_CONFIG.PRODUCT.path}
      text={ROUTE_CONFIG.PRODUCT.label}
      icon={<ShoppingBag  />}
    />
    
    <SideBarItem module={"faqs"} permission={"read_faqs"}
      link={ROUTE_CONFIG.FAQs.path}
      text={ROUTE_CONFIG.FAQs.label}
      icon={<BadgeQuestionMark />}
    />
    
    <SideBarItem module={"contact"} permission={"read_contact"}
      link={ROUTE_CONFIG.CONTACT_MESSAGES.path}
      text={ROUTE_CONFIG.CONTACT_MESSAGES.label}
      icon={<MessageCircle />}
    />
    <SideBarItem module={"subscriber"} permission={"read_subscriber"}
      link={ROUTE_CONFIG.SUBSCRIBERS_LIST.path}
      text={ROUTE_CONFIG.SUBSCRIBERS_LIST.label}
      icon={<Mail  />}
    />
    <SideBarItem noPermission
      link={ROUTE_PATHS.EMAIL_TEMPLATES}
      text="Email Templates"
      icon={<Send />}
    />
    */}
    <SideBarItem link={ROUTE_PATHS.SETTINGS} adminPermission text="Settings" icon={<Settings />} />
  </>

}
export default SideBarData;